import React, { useCallback } from 'react'
// import { Node, Panel } from 'reactflow';
// import { NODE_TYPE, NODE_TYPE_KEY } from '../nodes';
// import { IDControler, generateNodes } from '../../utils/generate';
// import { CustomNode } from '../nodes/type';
import useStoreInContext from 'src/hooks/useStoreInContext'
import styles from './index.less'
import { NODES } from '../../utils/basic'
import WrapperImage from '../configuration/wrapperImage'
import type { NODE_TYPE } from '../../utils/basic'

// interface PanelProps {
//   nodes: CustomNode[]
//   setNodes: (nodes: CustomNode[]) => void
//   // handleDragStart: React.Dispatch<React.SetStateAction<keyof typeof NODE_TYPE | null>>;
// }
export function CustomPanel() {
  // const panelClick = (key: keyof typeof NODE_TYPE) => {
  //   if (key === 'input' && nodes.some(node => node.type === 'input')) {
  //     return
  //   }
  //   if (key === 'output' && nodes.some(node => node.type === 'output')) {
  //     return
  //   }
  //   const id = String(IDControler.getId())
  //   const newNode = generateNodes[key](id)
  //   setNodes(nodes.concat(newNode))
  // }

  const isLock = useStoreInContext(state => state.isLock)

  const onDragStart = useCallback(
    (event: React.DragEvent<HTMLDivElement>, node: NODE_TYPE) => {
      if (isLock)
        return
      event.dataTransfer.setData('application/reactflow', node.value)
      event.dataTransfer.effectAllowed = 'move'
    },
    [isLock],
  )

  return (
    <div className={`${styles.panel}`}>
      <div className={`${styles.title}`}>
        <span className={`${styles.text}`}>节点</span>
      </div>
      <div className={styles.panelContent}>
        {NODES.map((node, i) => {
          return (
            <WrapperImage handleDragStart={onDragStart} node={node} key={i} />
          )
        })}
      </div>
    </div>
  //   <Panel
  //     position='top-left'
  //     className=' w-[280px] h-full bg-white m-0 p-[8px] flex flex-col items-center'
  //     // onDragEnd={(e: DragEvent<HTMLDivElement>) => {

  //   // }}
  // >
  //   {NODES.map((node) => {
  //     return <WrapperImage handleDragStart={onDragStart} node={node} />;
  //   })}
  // </Panel>
  )
}
